<template>
    <div class="container boxShadow">
        <div class="formbox">
            <div class="form_tabbar">
                <span :class="activeType==0?'active':''" @click="changeType(0)">密码登录</span>
                <span :class="activeType==1?'active':''" @click="changeType(1)">短信验证登录</span>
            </div>
            <custom-form :options="options" @carryData="catchFormData"></custom-form>
            <div class="form_footer">
                <span @click="$router.push('/forget')">忘记密码</span>
                <span @click="$router.push('/register')">立即注册</span>
            </div>
        </div>
    </div>
</template>

<script>
    import customForm from '../components/form.vue'
    export default {
        inject: ['ajax'],
        data() {
            return {
                activeType: 0,
                // phone - 手机号  vert - 图形验证码  code - 短信验证码  psw - 密码  repsw - 再次输入密码  notice - 法律生命  btn - 按钮
                options: {
                    phone: { name: '手机号' },
                    psw: { name: '密码' },
                    notice: false,
                    btn: { name: '登录' }
                }
            };
        },
        computed: {

        },
        created() {

        },
        mounted() {

        },
        methods: {
            catchFormData(data){
                if(this.activeType==0){
                    delete data.msg_captcha
                }else{
                    delete data.password
                }
                this.ajax('/api/login/login','post',this.$qs.stringify(data),res=>{
                    if(this.$route.query.login=="login"){
                        this.$router.go(-1)
                    }else{
                        this.$router.push('/myorder')
                    }  
                })
            },
            changeType(type) {
                if (this.activeType != type) {
                    this.activeType = type
                    if (type == 0) {
                        this.options = {
                            phone: { name: '手机号' },
                            psw: { name: '密码' },
                            notice: false,
                            btn: { name: '登录' }
                        }
                    }else{
                        this.options = {
                            phone: { name: '手机号' },
                            vert: { name: '验证码' },
                            code:{name:'动态码'},
                            notice: false,
                            btn: { name: '登录' }
                        }
                    }
                }
            }
        },
        components: {
            customForm
        },
    };
</script>

<style scoped>
     
    .container {
        min-height: 770px;
        background: url(../../public/images/login.jpg) 100% 100% no-repeat;
        position: relative;
    }

    .form_tabbar {
        width: 100%;
        display: flex;
        font-size: 1.2em;
        text-align: center;
        color: #111111;
        position: relative;
        padding: 15px 0;
    }

    .form_tabbar::after {
        content: '';
        position: absolute;
        width: 2px;
        height: 24px;
        background: #e3e3e3;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .form_tabbar>span {
        width: 50%;
        cursor: default;
    }

    .form_tabbar>span.active {
        color: #20a7fa;
    }

    @media only screen and (max-width: 750px){
        .container{background: #fff;}
        .formbox{width: 100%;position: relative;top: 0;right: 0;transform: translate(0,0)}
        .form_footer{font-size: 0.13rem;}
    }
</style>